import { useContext } from "react";
import CategoryFilterContent from "./CategoryFilterContent";
import CheckboxFilterContent from "./CheckboxFilterContent";
import SortFilterContent from "./SortFilterContent";
import AmountFilterContent from "./AmountFilterContent";
import DateFilterContent from "./DateFilterContent";
import { LanguageContext } from "../../../context/LanguageContext";

/**
 * Renders the correct filter content by type. All logic lives in the respective *FilterContent components.
 */
const FilterPopoverContent = ({
  activeConfig,
  normalizedOptions = [],
  selectedSet,
  selectedSingle,
  amountLocal,
  setAmountLocal,
  searchQuery,
  setSearchQuery,
  onMultiSelect,
  onSingleSelect,
  onAmountApply,
  onDateApply,
  selectedDate,
  onClose,
}) => {
  const [I18n] = useContext(LanguageContext);

  if (!activeConfig) return null;

  const {
    type,
    searchPlaceholder = I18n.search || "Search",
    minPlaceholder = I18n.minimum_amount || "Minimum amount",
    maxPlaceholder = I18n.maximum_amount || "Maximum amount",
    applyLabel = I18n.apply || "APPLY",
    placeholder = I18n.search_by_contact || "Search by contact",
    searchLabel = I18n.search || "SEARCH",
    exportLabel = I18n.export || "EXPORT",
    dateFilters,
  } = activeConfig;

  if (type === "date") {
    return (
      <DateFilterContent
        onFilterDate={onDateApply}
        onClose={onClose}
        exportLabel={exportLabel}
        dateFilters={dateFilters}
        selectedDate={selectedDate}
      />
    );
  }

  if (type === "amount") {
    return (
      <AmountFilterContent
        minValue={amountLocal.min}
        maxValue={amountLocal.max}
        onMinChange={(v) => setAmountLocal((p) => ({ ...p, min: v }))}
        onMaxChange={(v) => setAmountLocal((p) => ({ ...p, max: v }))}
        onApply={onAmountApply}
        minPlaceholder={minPlaceholder}
        maxPlaceholder={maxPlaceholder}
        applyLabel={applyLabel}
      />
    );
  }

  if (type === "sort") {
    return (
      <SortFilterContent
        options={normalizedOptions}
        selectedValue={selectedSingle}
        onSelect={onSingleSelect}
      />
    );
  }

  if (type === "category") {
    return (
      <CategoryFilterContent
        options={normalizedOptions}
        selectedSet={selectedSet}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        onToggleOption={onMultiSelect}
        searchPlaceholder={searchPlaceholder}
      />
    );
  }

  if (type === "checkbox") {
    return (
      <CheckboxFilterContent
        options={normalizedOptions}
        selectedSet={selectedSet}
        onToggleOption={onMultiSelect}
        preserveCase={activeConfig.preserveCase}
      />
    );
  }

  return null;
};

export default FilterPopoverContent;
